import { Highlight } from "prism-react-renderer";
import { Copy, Check } from "lucide-react";
import { codeTheme } from "./code-theme";
import { useCopyFeedback } from "@/hooks/use-copy-feedback";

interface CodeBlockProps {
  code: string;
  language: string;
  showLineNumbers?: boolean;
  title?: string;
}

export function CodeBlock({ code, language, showLineNumbers, title }: CodeBlockProps) {
  const { copiedValue, copy } = useCopyFeedback(true);
  const copied = copiedValue === true;

  return (
    <div className="relative group rounded-xl border border-code-border overflow-hidden">
      {title && (
        <div className="px-4 py-2 bg-white/[0.03] border-b border-code-border text-xs font-medium text-code-muted">
          {title}
        </div>
      )}
      <button
        onClick={() => copy(code, true)}
        className="absolute top-2 right-2 px-2 py-1 bg-white/[0.06] border border-code-border rounded-md text-code-muted text-xs hover:bg-white/[0.12] hover:text-code-text transition-colors cursor-pointer flex items-center gap-1 opacity-0 group-hover:opacity-100 z-10"
      >
        {copied ? <><Check className="w-3 h-3" /> Copied!</> : <><Copy className="w-3 h-3" /> Copy</>}
      </button>
      <Highlight theme={codeTheme} code={code.trim()} language={language}>
        {({ tokens, getLineProps, getTokenProps }) => (
          <pre className="bg-code-bg text-code-text p-4 overflow-x-auto text-sm font-mono leading-relaxed">
            {tokens.map((line, i) => (
              <div key={i} {...getLineProps({ line })} className="table-row">
                {showLineNumbers && (
                  <span className="table-cell pr-4 text-code-muted text-right select-none opacity-50 text-xs">
                    {i + 1}
                  </span>
                )}
                <span className="table-cell">
                  {line.map((token, key) => (
                    <span key={key} {...getTokenProps({ token })} />
                  ))}
                </span>
              </div>
            ))}
          </pre>
        )}
      </Highlight>
    </div>
  );
}
